import { takeLatest, put, call, cancelled } from 'redux-saga/effects';
import { normalize } from 'normalizr';

import {
  users as usersSchema,
  user as userSchema,
} from '../schema/user';
import {
  REQUEST_CLIENT_USERLIST_START,
  REQUEST_NON_CLIENT_USERLIST_START,
  REQUEST_EDITOR_USERLIST_START,
  ACCEPT_USER,
  REFUSE_USER,
  ADD_USER,
  REVIEWING_ASK,
  RESEND_ACCOUNT_ACTIVATION_EMAIL_START,
  EDIT_USER_START,
  REMOVE_USER_START,
} from '../actions';

angular.module('tct.sagas.users', [])
  .factory('usersSagaFactory', usersSagaFactory);

usersSagaFactory.$inject = [
  'actionsFactory',
  'accountsService',
  'mappingService',
];


function usersSagaFactory(actionsFactory, accountsService, mappingService) {
  const factory = {
    usersFlow,
  };

  const accountsListServiceFunctions = {
    REQUEST_CLIENT_USERLIST_START: accountsService.getClientAccounts,
    REQUEST_NON_CLIENT_USERLIST_START: accountsService.getNonClientAccounts,
    REQUEST_EDITOR_USERLIST_START: accountsService.getEditorAccounts,
  };

  return factory;

  function* getUserList(action) {
    try {
      const response = yield call(accountsListServiceFunctions[action.type], action.params);
      const pagination = mappingService.objectKeysToCamel(response.data && response.data.data);
      yield put(actionsFactory.reqUserListSuccess({
        items: normalize(pagination.items, usersSchema),
        total: pagination.totalItems,
      }));
      return response;
    } catch (err) {
      yield put(actionsFactory.reqUserListError((err.data && err.data.error) || err));
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }

    return 'done';
  }

  function* acceptUser(action) {
    try {
      yield call(accountsService.acceptUser, action.user);
      yield put(actionsFactory.acceptUserSuccess());
      yield put(actionsFactory.state());
    } catch (err) {
      yield put(actionsFactory.acceptUserError(err.data.error || err));
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }
    return 'done';
  }

  function* refuseUser(action) {
    try {
      yield call(accountsService.refuseUser, action.user, action.reason);
      yield put(actionsFactory.refuseUserSuccess());
      yield put(actionsFactory.state());
    } catch (err) {
      yield put(actionsFactory.refuseUserError(err.data.error || err));
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }
    return 'done';
  }

  function* addUser(action) {
    try {
      yield call(accountsService.addUser, action.user);
      yield put(actionsFactory.addUserSuccess());
      yield put(actionsFactory.state());
      return 'added';
    } catch (err) {
      yield put(actionsFactory.addUserError(err.data.error || err));
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }
    return 'done';
  }

  function* getReviewing(action) {
    try {
      const response = yield call(accountsService.fetchReviewing, action.client);
      const pagination = mappingService.objectKeysToCamel(response.data && response.data.data);

      yield put(actionsFactory.reqReviewingSuccess({
        items: normalize(pagination.items, usersSchema),
        total: pagination.totalItems,
      }));

      return response;
    } catch (err) {
      yield put(actionsFactory.reqReviewingError((err.data && err.data.error) || err));
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }
    return 'done';
  }

  function* resendAccountActivationEmail(action) {
    try {
      const response = yield call(accountsService.resendAccountActivationEmail, action.id);
      yield put(
        actionsFactory.resendAccountActivationEmailSuccess(
          normalize(
            mappingService.objectKeysToCamel(response.data && response.data.data), userSchema)));

      return response;
    } catch (err) {
      yield put(
        actionsFactory.resendAccountActivationEmailError(
          (err.data && err.data.error) || err));
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }

    return 'done';
  }

  function* editUser(action) {
    try {
      const userToEdit = Object.assign(action.user, {
        fullName: `${action.user.firstName} ${action.user.lastName}`,
      });

      const response = yield call(accountsService.editUser, userToEdit);
      const data = response.data && response.data.data;
      yield put(actionsFactory.editUserSuccess(data));
      yield put(actionsFactory.state());
    } catch (err) {
      yield put(actionsFactory.editUserError(err.data || err));
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }
  }

  function* removeUser(action) {
    try {
      const response = yield call(accountsService.removeUser, action.user.id);
      const data = response.data && response.data.data;
      yield put(actionsFactory.removeUserSuccess(data));
      yield put(actionsFactory.state());
    } catch (err) {
      yield put(actionsFactory.removeUserError(err.data || err));
    } finally {
      if (yield cancelled()) {
        console.log('cancelled');
      }
    }
  }

  function* usersFlow() {
    yield takeLatest([
      REQUEST_CLIENT_USERLIST_START,
      REQUEST_NON_CLIENT_USERLIST_START,
      REQUEST_EDITOR_USERLIST_START,
    ], getUserList);
    yield takeLatest(REVIEWING_ASK, getReviewing);
    yield takeLatest(ACCEPT_USER, acceptUser);
    yield takeLatest(REFUSE_USER, refuseUser);
    yield takeLatest(ADD_USER, addUser);
    yield takeLatest(RESEND_ACCOUNT_ACTIVATION_EMAIL_START, resendAccountActivationEmail);
    yield takeLatest(EDIT_USER_START, editUser);
    yield takeLatest(REMOVE_USER_START, removeUser);
  }
}
